
export class WorkrequestPsaDetails {

    developmentType:string
    numberOfLevels:number;
    numberOfBasements:number
    residentialLots:number;
    industrialLots:number;
    commercialLots:number;
    description:string;
    potableWaterServices :Water = new Water()
    recycledWaterServices: Recycle= new Recycle()
    sewerServices:Sewer= new Sewer()
}


export class Water{
    
    //WaterConnectionType:string
    firewaterConnectionType:string
    generalwaterConnectionType:string
    waterServiceSize:number
    fireServiceSize:number
    generalServiceSize:number
    hydrantFlowRate:number
    sprinklerFlowRate:number;
    generalFlowRate:number;
    waterTappingLocation:boolean
    inLinePumpsUsed:any
    inlinePumps : any
}

export class Recycle{

    usedforIrrigation:boolean
    usedforToiletFlushing:boolean
    recycledServiceSize:number
    demand:number;
    recycledWaterTappingLocation:boolean
    inLinePumpsUsed:boolean
    inlinePumps : any

    constructor() {
      this.inLinePumpsUsed= false
        
    }
}

export class Sewer{

    totalSewerLoading:number
    fixtureQuantity:number
    nonResidentialFloorSpace:number
    sewerConnectionLocation:boolean
    internalSewerPumping:any
}

export class WorkrequestGreenField {

    developmentType:string
    greenResidentialLots:number
    residentialDwellings:number
    residentialUnits:number
    commercialLotsSize:number
    industrialLotsWarehouse:number
    industrialLotsManufacturing:number
    industrialLotsStorage:number

}




// WEBPACK FOOTER //
// ./src/app/create-application/psa-form/workrequest-psa-details.ts